export const EFFECTIVE_MIN_DAY = 15;
